var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('button',{staticClass:"trash-btn btn btn-warning mt-0 float-left",on:{"click":_vm.startEdit}},[_c('font-awesome-icon',{attrs:{"icon":"edit"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }